import { render, staticRenderFns } from "./PersonalNotificationSettingsPage.vue?vue&type=template&id=54ff3055&lang=pug&"
import script from "./PersonalNotificationSettingsPage.vue?vue&type=script&lang=js&"
export * from "./PersonalNotificationSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./PersonalNotificationSettingsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports